module.exports = __webpack_public_path__ + "img/seahorse.be5030ca.webp";